export default "__VITE_ASSET__D5Ach_T7__"